import { render, staticRenderFns } from "./OrdeBasicrDetail.vue?vue&type=template&id=a30ddef0"
import script from "./OrdeBasicrDetail.vue?vue&type=script&lang=js"
export * from "./OrdeBasicrDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports